<template>
    <div
        class="flex h-full w-full flex-col items-center justify-center gap-5"
        data-testid="RequestErrorPage"
    >
        <div class="">
            <NuxtImg
                src="/images/error.svg"
                alt=""
                sizes="300px sm:320px"
                class="mb-10"
            />
            <slot name="errorMessage" />
        </div>
    </div>
</template>
